import type { ReactNode } from 'react';

export const symbol_video_search: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M318-516v-139q0-9 7.5-13.5t15.5.5l111 69q7 5 7 13t-7 13l-111 70q-8 5-15.5.5T318-516Zm60 187q-108 0-183-75t-75-181q0-106 75-181t182-75q106 0 180.5 75T632-585q0 43-14 83t-42 75l242 240q9 9 9 22t-9 22q-9 9-22 9t-22-9L533-384q-30 26-70 40.5T378-329Zm-1-60q81 0 138-57.5T572-585q0-81-57-138.5T377-781q-82 0-139.5 57.5T180-585q0 81 57.5 138.5T377-389Z"
		/>
	</svg>
);
